import formatIsoDate from '@/services/general/formatIsoDate';
import cloneDeep from 'lodash/cloneDeep';

export default function preparationEnvoiBack(relance, isSave) {
  const copieRelance = cloneDeep(relance);
  if (isSave) delete copieRelance.id;
  if (copieRelance.dateRelance) {
    copieRelance.dateRelance = formatIsoDate(copieRelance.dateRelance);
  }
  return copieRelance;
}
